import React from 'react';
import './LegalPages.css';

const About = () => {
  return (
    <div className="legal-page">
      <section className="legal-header">
        <div className="legal-header-content">
          <h1>About DocuAIHub</h1>
          <p className="subtitle">Transform Your Document Workflow with AI</p>
          <p className="description">
            DocuAIHub is a cutting-edge document management platform powered by artificial intelligence.
          </p>
        </div>
      </section>

      <section className="legal-content">
        <div className="content-wrapper">
          <aside className="table-of-contents">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="#mission">Our Mission</a></li>
              <li><a href="#features">What We Offer</a></li>
              <li><a href="#team">Our Team</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </aside>

          <main className="main-content">
            <section id="mission" className="content-section">
              <h2>Our Mission</h2>
              <p>
                At DocuAIHub, our mission is to revolutionize document management through the power of artificial intelligence. 
                We believe that managing documents should be effortless, secure, and intelligent.
              </p>
              <p>
                We're committed to providing businesses and individuals with tools that save time, reduce costs, 
                and enhance productivity through smart automation and AI-powered insights.
              </p>
            </section>

            <section id="features" className="content-section">
              <h2>What We Offer</h2>
              <p>DocuAIHub provides a comprehensive suite of document management tools:</p>
              <ul>
                <li><strong>AI-Powered Analysis:</strong> Extract insights, summaries, and key information automatically</li>
                <li><strong>Document Conversion:</strong> Convert between multiple formats with perfect accuracy</li>
                <li><strong>Digital Signatures:</strong> Sign documents securely with legally binding e-signatures</li>
                <li><strong>Smart Compression:</strong> Reduce file sizes without quality loss</li>
                <li><strong>OCR Technology:</strong> Extract text from scanned documents and images</li>
                <li><strong>Multi-language Support:</strong> Process documents in over 100 languages</li>
              </ul>
            </section>

            <section id="team" className="content-section">
              <h2>Our Company</h2>
              <p>
                DocuAIHub is operated by <strong>AMB GLOBAL DIGITAL SOLUTIONS LTD</strong>, a technology company 
                specialized in AI-powered business solutions.
              </p>
              <p><strong>Company Information:</strong></p>
              <ul>
                <li>Entity: AMB GLOBAL DIGITAL SOLUTIONS LTD</li>
                <li>Location: 1 Maiou 3, 2610 Agios Epifanios Oreinis, Cyprus</li>
                <li>Registration: CY12345678</li>
                <li>Website: <a href="https://www.ambglobaldigital.com" target="_blank" rel="noopener noreferrer">www.ambglobaldigital.com</a></li>
              </ul>
            </section>

            <section id="contact" className="content-section">
              <h2>Get in Touch</h2>
              <p>We'd love to hear from you! Contact us for any questions or support:</p>
              <ul>
                <li><strong>Email:</strong> <a href="mailto:help@docuaihub.com">help@docuaihub.com</a></li>
                <li><strong>Phone:</strong> +357 77788373</li>
                <li><strong>Business Hours:</strong> Monday - Friday, 9:00 AM - 6:00 PM CET</li>
              </ul>
            </section>
          </main>
        </div>
      </section>
    </div>
  );
};

export default About;
